import { render, staticRenderFns } from "./NotificationPermissionUpdate.vue?vue&type=template&id=624fefca"
import script from "./NotificationPermissionUpdate.vue?vue&type=script&lang=js"
export * from "./NotificationPermissionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports